import { IDictionary } from '@/utilities/IDictionary';
import LoanPurposeEnum from '@/Api/Deal/LoanPurposeEnum';

export const loanPurposeLabels: IDictionary<string> = {
    [LoanPurposeEnum.BridgingLoan]: 'Buy and sell property',
    [LoanPurposeEnum.BusinessLoan]: 'Grow and expand my business',
    [LoanPurposeEnum.DevelopmentLoan]: 'Development / construction finance',
    [LoanPurposeEnum.PersonalLoan]: 'Personal loan',
    [LoanPurposeEnum.Refinance]: 'Refinance or equity loan',
    [LoanPurposeEnum.RenovateOrBuild]: 'Renovation loan',
};
